import HTTP from "../../http-common"

export function login(data) {
	return HTTP.post("users/login/", data, true)
}

export function getUserData(userId) {
	return HTTP.get(`users/info/`)
}

// Segundo paso del login cuando el back responde mfa_required: la sesión
// (cookies + csrf_token) nace aquí, no en users/login/.
export function validateMfa(data) {
	return HTTP.post('users/mfa/validate/', data, true)
}

export function resendMfa(data) {
	return HTTP.post('users/mfa/resend/', data, true)
}

export function recoveryPassword(data) {
	return HTTP.post('/rest-auth/password/reset/', data, true)
}

export function logout() {
	return HTTP.post('users/logout/', null, false)
}
